import React, { useEffect, useState, useContext } from 'react';
import FieldDropdown from '../../../components/FieldDropdown/FieldDropdown';
import FieldText from '../../../components/FieldText/FieldText';
import FieldCheck from '../../../components/FieldCheck/FieldCheck';
import { API } from '../../../API/API';
import { UserContext } from '../../../context/UserContext';
import { message } from 'antd';
import { MessageConst } from '../../../const/MessageConst';
import GridJob from '../../../components/GridJob/GridJob';
import ButtonSecondaryIcon from '../../../components/ButtonSecondaryIcon/ButtonSecondaryIcon';
import { constData } from '../../../const/Const';
import FieldItemList from '../../../components/FieldItemList/FieldItemList';
import ButtonDefaultWithLoad from '../../../components/ButtonDefaultWithLoad/ButtonDefaultWithLoad';
import PanelBase from '../../../components/PanelBase/PanelBase';

const Position = (props) => {

    const { userInfo } = useContext(UserContext);

    const [step, setStep] = useState(1);
    const [dType] = useState(constData.hrPosition_Type);
    const [dLabourCondition] = useState(constData.hrContract_LabourCondition);
    const [checkRule, setCheckRule] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const [warning, setWarning] = useState();

    const [initialData] = useState(
        {
            "positionid": -1,
            "companyid": userInfo.companyid.toUpperCase(),
            "jobid": null,
            "code": null,
            "name": null,
            "vacancydays": 0,
            "jdecostcenter": null,
            "type": "B",
            "depid": null,
            "labourcondition": null,
            "positionoccid": null,
            "isactive": true,
            "managerpos": [],
            "posgroupid": null,
            "employmenttypeid": null,
            "gradeid": null
        }
    );

    const [data, setData] = useState({ ...initialData });

    const getExistData = async () => {
        if (props.positionid > 0) {
            let tData = { ...initialData };

            setLoading(true);
            await API.get('/api/humanresource/organization/get_position?positionid=' + props.positionid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });
            setLoading(false);
            setData(tData);
        }
    }

    useEffect(() => {
        getExistData();
    }, [props.positionid])

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }

            if (field == 'positionoccid') {
                await API.get('/api/humanresource/organization/get_position_occ_dropdown?positionoccid=' + key).then(response => {
                    if (response.status == 200 && response.data.rettype == 0) {
                        if (response.data.retdata?.length > 0) {
                            tData.code = response.data.retdata[0].code;
                            tData.name = response.data.retdata[0].name;
                        }
                    }
                });
            }

            setData(tData);
        }
    }

    const onSave = async () => {
        let vRule = true;
        let tData = { ...data };

        if (!tData.depid) {
            vRule = false;
            setWarning("Дотоод нэгж" + MessageConst.fieldRequired);
        } else if (!tData.code) {
            vRule = false;
            setWarning("Код" + MessageConst.fieldRequired);
        } else if (!tData.name) {
            vRule = false;
            setWarning("Нэр" + MessageConst.fieldRequired);
        }

        if (tData?.managerpos?.length > 0) {

            let tManagerPost = [...tData.managerpos.filter(r => r.rowstate != 0)];
            tData.managerpos = tManagerPost;

            if (tData?.managerpos?.length > 0) {
                tData.managerpos.map(r => {
                    if (!r.type) {
                        vRule = false;
                        setWarning("Удирдлага (Төрөл)" + MessageConst.fieldRequired);
                    } else if (!r.managerpositionid) {
                        vRule = false;
                        setWarning("Удирдлага (Ажлын байр)" + MessageConst.fieldRequired);
                    }
                });
            }
        }

        if (vRule) {
            setLoadingSave(true);
            await API.post('/api/humanresource/organization/save_position', [tData]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    setCheckRule(false);
                    clearState();
                    props.afterSave();
                }
            });
            setLoadingSave(false);
        }
    }

    const deleteC = () => {
        API.post('/api/humanresource/organization/delete_position?positionid=' + props.positionid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                props.afterSave();
            }
        });
    }

    const onDismiss = () => {
        clearState();
        setCheckRule(false);
        props.onDismiss();
    }

    const clearState = () => {
        setData({ ...initialData });
        setWarning();
        setStep(1);
    }

    let vpanel = null;

    if (step == 1) {
        vpanel = (
            <div>
                <div style={{ marginTop: 25 }}>
                    <FieldItemList loading={loading} title="Ажил мэргэжлийн ангилал (ҮАМАТ)" onChanged={fieldOnChanged} keyfield='positionoccid' keyfieldname='positionoccname' defaultValue={[{ key: data.positionoccid, name: data.positionoccname }]} dataurl="/api/humanresource/organization/get_position_occ_dropdown" />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown loading={loading} title="Ажил эрхлэлтийн төрөл" onChanged={fieldOnChanged} data={dType} keyfield='type' defaultValue={data.type} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText loading={loading} required title="Код" onChanged={fieldOnChanged} keyfield='code' defaultValue={data.code} checkreq={checkRule} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText loading={loading} required title="Нэр" onChanged={fieldOnChanged} keyfield='name' defaultValue={data.name} checkreq={checkRule} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldItemList loading={loading} required title="Дотоод нэгж" onChanged={fieldOnChanged} keyfield='depid' keyfieldname='depname' defaultValue={[{ key: data.depid, name: data.depname }]} checkreq={checkRule} dataurl={'/api/humanresource/organization/get_department_dropdown'} dataparam={[{ key: 'companyid', name: userInfo.companyid.toUpperCase() }]} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown loading={loading} title="Хөдөлмөрийн нөхцөл" onChanged={fieldOnChanged} data={dLabourCondition} keyfield='labourcondition' defaultValue={data.labourcondition} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldItemList loading={loading} onChanged={fieldOnChanged} title="Зэрэг" keyfield='gradeid' keyfieldname='gradename' defaultValue={[{ key: data.gradeid, name: data.gradename }]} dataurl="/api/humanresource/Organization/get_grade_dropdown" />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldCheck loading={loading} title="Идэвхтэй эсэх" onChanged={fieldOnChanged} keyfield='isactive' defaultValue={data.isactive} />
                </div>
            </div>
        );
    } else if (step == 2) {
        vpanel = (
            <div>
                <GridJob onChanged={fieldOnChanged} keyfield='managerpos' defaultValue={data.managerpos} />
            </div>
        );
    }

    const onNextStep = () => {

        let tRule = true;
        if (step == 1) {
            setCheckRule(true);
            if (!data.depid
                || !data.code
                || !data.name) {
                tRule = false;
            }
        }

        if (tRule && step < 2) {
            setStep(r => r + 1);
        }
    }

    const onPrevStep = () => {
        if (step > 1) {
            setStep(r => r - 1);
        }
    }

    return (
        <div>
            <PanelBase
                isOpen={props.isOpen}
                onDismiss={onDismiss}
                isFooterAtBottom={true}
                headerText={props.positionid > 0 ? "Ажлын байр засах" : "Ажлын байр нэмэх"}
                onDelete={deleteC}
                warning={warning}
                delete={props.positionid}
                buttons={
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {step != 1 && (
                                    <div style={{ marginRight: 16 }}>
                                        <ButtonSecondaryIcon iconName='DoubleChevronLeft8' onClick={onPrevStep} text="Буцах" />
                                    </div>
                                )}
                                {step != 2 && (
                                    <div style={{ marginRight: 16 }}>
                                        <ButtonSecondaryIcon iconName='DoubleChevronRight8' onClick={onNextStep} text="Үргэлжлүүлэх" />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                            {step == 2 ? (<ButtonDefaultWithLoad loading={loadingSave} onClick={onSave} text="Хадгалах" />) : null}
                        </div>
                    </div>
                }
            >
                <div style={{ marginTop: 22, fontSize: 18 }}>
                    {step == 1 ? "Үндсэн" : "Удирдлага"} {step}/2
                </div>
                {vpanel}
            </PanelBase>
        </div>
    );
}

export default Position;